import comp from "./ShortcutsPage";
export default comp;
